import { Card, CardActionArea, CardContent, Grid, Skeleton, Typography } from '@mui/material'
import { toDollars } from '@wolfdanepug/common-react'
import moment from 'moment'
import { NavLink } from 'react-router'
import { buildLink } from '../../utils'

export default function OrderItem({ item, index, loading = false }: any) {
	return (
		<Card sx={{ width: '100%' }}>
			<CardActionArea component={NavLink} to={buildLink('settings', 'orders', item.id)}>
				<CardContent sx={{ '&:last': { pb: 2 } }}>
					<Grid container spacing={2}>
						{loading ? (
							<>
								<Grid item md={1}>
									<Skeleton variant="text" />
								</Grid>
								<Grid item md={8}>
									<Skeleton variant="text" />
								</Grid>
								<Grid item md={1}>
									<Skeleton variant="text" />
								</Grid>
								<Grid item md={2}>
									<Skeleton variant="text" />
								</Grid>
							</>
						) : (
							<>
								<Grid item md={1}>
									<Typography>{index}</Typography>
								</Grid>
								<Grid item md={8}>
									<Typography variant="h6">Gourmet Starter Box</Typography>
								</Grid>
								<Grid item md={1}>
									<Typography>$ {toDollars(item.total)}</Typography>
								</Grid>
								<Grid item md={2}>
									<Typography>{moment(item.createdAt).format('MMMM Do YYYY')}</Typography>
								</Grid>
							</>
						)}
					</Grid>
				</CardContent>
			</CardActionArea>
		</Card>
	)
}
